import React, { useState, useCallback } from 'react';
import { isInternetExplorer } from '../../Utils/utils';
import BrowserRecommendationDialogView from './BrowserRecommendationDialogView';

/**
 * En dialog som visas om användaren använder en browser som sidan har dåligt stöd för.
 */
const BrowserRecommendationDialog: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const [open, setOpen] = useState(isInternetExplorer());

  return (
    <BrowserRecommendationDialogView
      open={open}
      close={useCallback(() => setOpen(false), [])}
    />
  );
};

export default BrowserRecommendationDialog;
